import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const dest = localStorage.getItem("post_login_redirect") || "/";

    (async () => {
      try {
        const { data } = await publicApi.post(
          "/auth/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data.user);
      } catch (e) {
        console.error("Session exchange failed", e);
      } finally {
        localStorage.removeItem("post_login_redirect");
        window.history.replaceState({}, "", dest);
        navigate(dest, { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-gold/30 border-t-gold rounded-full animate-spin mx-auto" />
        <p className="mt-6 font-serif text-xl text-gold">Idea Events USA</p>
        <p className="mt-1 text-muted2 text-sm">Signing you in…</p>
      </div>
    </div>
  );
}
